import { useWeb3React } from '@web3-react/core';
import axios from 'axios';
import React, { useContext, useEffect } from 'react'
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';
import Web3 from 'web3';

import { AppContext } from '../../../AppContext';
import MintableToken from '../../../interfaces/MintableTokens';
import MintSignature from '../../../interfaces/MintSignature';
import MintTransactionStatus from '../../../interfaces/MintTransactionStatus';
import Balance from '../../Balance';
import FigureDetail from '../../FigureDetail';
import FigureDisplay from '../../FigureDisplay';
import ModalButtonBar from '../../ModalButtonBar';
import ModalChoice from '../../ModalChoice';
import ModalContainer from '../../ModalContainer';
import Timer from '../../Timer/Timer';

import './MintableItem.scss';

declare var window: any;

interface IProps {
    token:MintableToken;
    updateTokenList(tokens:MintableToken[]):void;
    balance:number;
    chainId:number;
}

const proxyMintContractAbi:any = [ { "inputs": [ { "internalType": "uint8", "name": "_v", "type": "uint8" }, { "internalType": "bytes32", "name": "_r", "type": "bytes32" }, { "internalType": "bytes32", "name": "_s", "type": "bytes32" }, { "internalType": "string", "name": "addy", "type": "string" }, { "internalType": "string", "name": "tokenId", "type": "string" }, { "internalType": "string", "name": "url", "type": "string" }, { "internalType": "string", "name": "price", "type": "string" } ], "name": "callProxyMint", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [ { "internalType": "address payable", "name": "_to", "type": "address" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "transfer", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "inputs": [ { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "withdraw", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "getBalance", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "goldCrowAddress", "outputs": [ { "internalType": "address payable", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "Owner", "outputs": [ { "internalType": "address payable", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "price", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "requestingAddy", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "testadd", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "testhash", "outputs": [ { "internalType": "bytes32", "name": "", "type": "bytes32" } ], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "tokenId", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "stateMutability": "view", "type": "function" } ];

const MintableItem = (props: IProps) => {
    const token = props.token;
    const web3 = new Web3(window.ethereum);
    const web3_bsc = new Web3('https://bsc-dataseed1.binance.org:443');
   // web3.eth.handleRevert = true
    const context = React.useContext(AppContext);
    const session = context.userSession;
    const [minting, setMinting] = React.useState<boolean>(false);
    const [mintingOverride, setMintingOverride] = React.useState<boolean>(false);
    function setMintableTokens(tokens:MintableToken[]):void {
        props.updateTokenList(tokens);
    }


    function overrideLock() {
        setMintingOverride(true);
    }

    function onCorrectChain():boolean {
        if(props.chainId === 56) {
            return true;
        } else {
            return false;
        }
    }

    function canAfford():boolean {
        if(props.balance > Number(token.price)) {
            return true;
        } else {
            return false;
        }
    }

    async function mintToken(mintableToken:MintableToken) {
        setMintingOverride(false);
        try {
            await window.ethereum.request({
              method: 'wallet_switchEthereumChain',
              params: [{ chainId: '0x38' }],
            });
          } catch (switchError:any) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
              try {
                await window.ethereum.request({
                    method: 'wallet_addEthereumChain',
                    params: [{
                    chainId: '0x38',
                    chainName: 'Binance Smart Chain',
                    nativeCurrency: {
                        name: 'Binance Coin',
                        symbol: 'BNB',
                        decimals: 18
                    },
                    rpcUrls: ['https://bsc-dataseed.binance.org/'],
                    blockExplorerUrls: ['https://bscscan.com']
                    }]
                    });
              } catch (addError) {
                // handle "add" error
              }
            }
            // handle other "switch" errors
          }
            let url = `${process.env.REACT_APP_SERVICE_BASEPATH}/user/mintToken`;
            setMinting(true);
            context.setShowLoader?.(`Minting ${mintableToken.tokenDetail.name} ${mintableToken.tokenDetail.edition}/${mintableToken.tokenDetail.totalEditions}`, true);
            axios({
                "method": "POST",
                "url": url,
                "headers": {
                    "signedMessage": session?.signature as string,
                    "originalMessage": session?.message as string,
                    "address": session?.address as string,
                    'content-type': 'application/json'
                },
                "data": mintableToken.id
    
            })
                .then((response) => {
                   // let updatedUser:User = response.data;
                    let mintSignature = response.data;
                    callProxyMint(mintableToken, mintSignature);
                    //context.setShowLoader?.(`Minting ${mintableToken.tokenDetail.name} ${mintableToken.tokenDetail.edition}/${mintableToken.tokenDetail.totalEditions}`, false);
                })
                .catch((error) => {
                    console.log(error)
                    context.setShowLoader?.(`Minting ${mintableToken.tokenDetail.name} ${mintableToken.tokenDetail.edition}/${mintableToken.tokenDetail.totalEditions}`, false);
                    setMinting(false);
                })
    }

    function updateTransactionStatus(status:MintTransactionStatus) {
        
        let url = `${process.env.REACT_APP_SERVICE_BASEPATH}/user/updateTransactionStatus`;
        //setMinting(true);
        //context.setShowLoader?.(`Minting ${mintableToken.tokenDetail.name} ${mintableToken.tokenDetail.edition}/${mintableToken.tokenDetail.totalEditions}`, true);
        axios({
            "method": "POST",
            "url": url,
            "headers": {
                "signedMessage": session?.signature as string,
                "originalMessage": session?.message as string,
                "address": session?.address as string,
                'content-type': 'application/json'
            },
            "data": status

        })
            .then((response) => {
               // let updatedUser:User = response.data;
                let updatedMintList = response.data;
                setMintableTokens(updatedMintList);
                setMinting(false);
                //callProxyMint(mintableToken, mintSignature);
                context.setShowLoader?.(`Minting ${props.token.tokenDetail.name} ${props.token.tokenDetail.edition}/${props.token.tokenDetail.totalEditions}`, false);
            })
            .catch((error) => {
                console.log(error)
                //context.setShowLoader?.(`Minting ${mintableToken.tokenDetail.name} ${mintableToken.tokenDetail.edition}/${mintableToken.tokenDetail.totalEditions}`, false);
                setMinting(false);
                context.setShowLoader?.(`Minting ${props.token.tokenDetail.name} ${props.token.tokenDetail.edition}/${props.token.tokenDetail.totalEditions}`, false);
            })
}

    async function callProxyMint(mintableToken:MintableToken, mintSignature:MintSignature) {
        
        
        if (window.ethereum && session?.address) {
            
            //let contract = new web3.eth.Contract(proxyMintContractAbi, "0xF03C651F206a8Baaab7aE6464cF6e429F4FeD795");
            let contract = new web3.eth.Contract(proxyMintContractAbi, "0x36d6d8dc04De3F77c432E46d0F9cE5dbceA11c94");
            let validationTx = await contract.methods.callProxyMint(
                mintSignature.v,
                mintSignature.r,
                mintSignature.s,
                mintSignature.address,
                mintSignature.tokenId,
                mintSignature.metadataUrl,
                mintSignature.price).estimateGas({from:session?.address, value:mintSignature.price}).catch((revertReason:any) => console.log({ revertReason }));
            
            //estimate gas succeeds    
            if (validationTx) {
                let mintTx = await contract.methods.callProxyMint(
                    mintSignature.v,
                    mintSignature.r,
                    mintSignature.s,
                    mintSignature.address,
                    mintSignature.tokenId,
                    mintSignature.metadataUrl,
                    mintSignature.price).send({from:session?.address, value:mintSignature.price}).catch((revertReason:any) => {
                        
                        //code 4001 user cancelled, -32000 insufficient funds, code -32603 problem on contract, 'TxGasUtil - Trying to call a function on a non-contract address'
                        if (revertReason.code === 4001 || revertReason.code === -32000 || String(revertReason.message).startsWith('TxGasUtil - Trying to call a function on a non-contract address')) {
                            let transactionStatus:MintTransactionStatus = {} as MintTransactionStatus;
                            transactionStatus.mintableToken = mintableToken;
                            transactionStatus.status = false;
                            transactionStatus.transactionHash = '';
                            updateTransactionStatus(transactionStatus);
                            context.setShowLoader?.(`Cancelling Mint`, true);
                        } else {
                            let transactionStatus:MintTransactionStatus = {} as MintTransactionStatus;
                            transactionStatus.mintableToken = mintableToken;
                            transactionStatus.status = false;
                            transactionStatus.transactionHash = '';
                            updateTransactionStatus(transactionStatus);
                            context.setShowLoader?.(`Cancelling Mint`, true);
                        }
                        
                    });
                //console.log(mintTx);
                //check if mintTx is populated and status is true
                if(mintTx && mintTx.status !== undefined) {
                    let transactionStatus:MintTransactionStatus = {} as MintTransactionStatus;
                    transactionStatus.mintableToken = mintableToken;
                    transactionStatus.status = mintTx.status;
                    transactionStatus.transactionHash = mintTx.transactionHash;
                    updateTransactionStatus(transactionStatus);
                    context.setShowLoader?.(`Confirming Transaction`, true);
                }
            } else {
                let transactionStatus:MintTransactionStatus = {} as MintTransactionStatus;
                    transactionStatus.mintableToken = mintableToken;
                    transactionStatus.status = false;
                    transactionStatus.transactionHash = '';
                    updateTransactionStatus(transactionStatus);
                    context.setShowLoader?.(`Cancelling Mint`, true);
            }
        }

    }

    return (
        
                        <div className={'mintable-item ' + token.status}>
                            
                            <FigureDisplay token={token.tokenDetail} size={'half'} />
                            <FigureDetail figure={token.tokenDetail} edition={token.tokenDetail.edition} totalEditions={token.tokenDetail.totalEditions} />
                            <div className='mintable-item-details'>
                                <dl>
                                    <div className='data-item'>
                                        <dt>Received:</dt>
                                        <dd>{new Date(token.createDate).toLocaleString()}</dd>
                                    </div>
                                    <div className='data-item'>
                                        <dt>Expires:</dt>
                                        <dd>{token.expireDate ? new Date(token.expireDate).toLocaleString() : 'End of Time'}</dd>
                                        </div>
                                        <div className='data-item'>
                                        <dt>Source:</dt>
                                        <dd>{token.source} ({token.sourceDescription})</dd>
                                    </div>
                                    {token.status === 'minted' && <div className='data-item'>
                                        <dt>Minted</dt>
                                        <dd>{new Date(token.mintDate).toLocaleString()}<br />{Number(token.price) > 0 ? (token.price + ' BNB') : '' }  <a href={`https://bscscan.com/tx/${token.txHash}`} target='_blank'>view transaction</a></dd>
                                    </div>}
                                </dl>
                            </div>
                            {token.status != 'minted' && token.status != 'expired' && !onCorrectChain() && <div className='info-text'>Incorrect Chain ({props.chainId})</div>}
                            {token.status != 'minted' && token.status != 'expired' && onCorrectChain() && !canAfford() && <div className='info-text'>Insufficient Funds</div>}
                            { token.status != 'minted' && token.status != 'expired' && (token.lockSeconds || minting) && !mintingOverride && <div className='info-text'>Pending Approval <Timer onTimerEnd={overrideLock} initialSeconds={token.lockSeconds || 60} />s</div>}
                            
                            { token.status != 'minted' && token.status != 'expired' && <div className='mint-area'>
                                <div className={'total ' + (Number(token.price) == 0 ? 'no-cost' : '')}><img src='/bsc_logo.png' />{token.price}</div>
                                <div>
                                <button className='mint-button' disabled={!canAfford() || !onCorrectChain() || minting || (token.lockSeconds > 0 && !mintingOverride)} onClick={() => mintToken(token)}>Mint</button>
                                
                                </div>
                            </div>}
                            { token.status == 'expired' && <div className='mint-area'>
                                <div className={'total ' + (Number(token.price) == 0 ? 'no-cost' : '')}><img src='/bsc_logo.png' />{token.price}</div>
                                <div>
                                    <div className="expired-mint-button">Expired</div>    
                                    
                                </div>
                            </div>}
                            {minting && ReactDOM.createPortal(
                <ModalChoice>
                    <ModalContainer className='minting-modal' >

                        <h2>Minting {token.tokenDetail.name} {token.tokenDetail.edition}/{token.tokenDetail.totalEditions}</h2>
                        <FigureDisplay token={token.tokenDetail} size='half' />
                        <div className='modal-warning'><strong>PLEASE CONFIRM THE TRANSACTION USING YOUR WALLET</strong><p>Do not close or refresh until minting is complete.</p><p>After minting it may take a few minutes for the new Figure to show up in your inventory.</p></div>
                        <div className='waiting-message-wrapper'>
                            <div className="waiting-message">Awaiting Confirmation</div>
                            <div className="waiting-message">Your Crow is Preparing to Fly</div>
                        </div>
                    </ModalContainer>
                </ModalChoice>
                , document.body)
            }
                        </div>
                    
    )
}

export default MintableItem;